module.exports = __webpack_public_path__ + "static/media/23.2ba2f994.jpg";